var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatering(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_18606)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96926 39.9958L10.755 37.4127C11.4176 36.8328 12.2739 36.5226 13.1546 36.5438L24.966 36.8259L36.368 26.0806L35.5145 25.227C33.2399 22.9523 29.5602 22.9389 27.2689 25.1866L23.6331 28.2031H14.9407V30.5469H24.4787L28.8469 26.9228L28.8854 26.8843C29.9567 25.8129 31.5475 25.5776 32.847 26.1782L24.0593 34.4599L13.2109 34.2007C13.2109 34.2007 13.211 34.2007 13.2109 34.2007C11.7357 34.1653 10.3012 34.6878 9.19448 35.664L9.18355 35.6736L7.94551 36.8216L4.19047 33.4428L10.5819 26.8841C11.2407 26.2279 12.1328 25.8594 13.0629 25.8594V23.5156C11.5089 23.5156 10.0185 24.1329 8.91965 25.2319L8.90898 25.2425L0.809769 33.5537L7.96926 39.9958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9719 4.6875C13.5582 4.6875 6.65942 11.5863 6.65942 20H9.00317C9.00317 12.8807 14.8526 7.03125 21.9719 7.03125C29.0828 7.03125 34.8625 12.8723 34.8625 20H37.2063C37.2063 11.5948 30.394 4.6875 21.9719 4.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68759 21.1719H38.2463C37.746 22.5266 36.4094 23.5156 34.8625 23.5156H9.00317C7.47245 23.5156 6.17021 22.5373 5.68759 21.1719ZM3.14379 20C3.14379 23.236 5.76713 25.8594 9.00317 25.8594H34.8625C38.0733 25.8594 40.8 23.261 40.8 20V18.8281H3.14379V20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4563 3.51563C18.4563 5.45721 20.0303 7.03125 21.9719 7.03125C23.9135 7.03125 25.4875 5.45721 25.4875 3.51563C25.4875 1.57404 23.9135 0 21.9719 0C20.0303 0 18.4563 1.57404 18.4563 3.51563ZM21.9719 4.6875C21.3247 4.6875 20.8 4.16279 20.8 3.51563C20.8 2.86846 21.3248 2.34375 21.9719 2.34375C22.6191 2.34375 23.1438 2.86846 23.1438 3.51563C23.1438 4.16279 22.6191 4.6875 21.9719 4.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4586 25.8594C20.3982 25.8594 21.9719 27.4338 21.9719 29.375H24.3157C24.3157 26.1409 21.6941 23.5156 18.4586 23.5156V25.8594Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_18606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.800034)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatering);
export default __webpack_public_path__ + "static/media/Catering.9cb53072f962b1ae260e1badc77d11e7.svg";
export { ForwardRef as ReactComponent };